// React context + Provider para WSClient (v0.2.0)
// Apps envuelven <WSClientProvider client={wsClient}> en root tree.

import { createContext, useContext, type ReactNode } from 'react'
import type { WSClient } from './client'

const WSClientContext = createContext<WSClient | null>(null)

export function WSClientProvider({
  client,
  children,
}: {
  client: WSClient
  children: ReactNode
}) {
  return <WSClientContext.Provider value={client}>{children}</WSClientContext.Provider>
}

export function useWSClient(): WSClient {
  const client = useContext(WSClientContext)
  if (!client) {
    throw new Error('useWSClient must be used within <WSClientProvider>')
  }
  return client
}
